'use client'

import { FloppyDiskIcon, XIcon } from '@phosphor-icons/react'
import { Button } from '@/ui/button'

interface EditFormActionsProps {
  isSaving: boolean
  onCancel: () => void
  onSave: () => void
  disabled?: boolean
}

export function EditFormActions({
  isSaving,
  onCancel,
  onSave,
  disabled,
}: EditFormActionsProps) {
  return (
    <div className="flex items-center justify-end gap-2 pt-2">
      <Button
        variant="ghost"
        size="sm"
        onClick={onCancel}
        disabled={isSaving}
        className="h-7 px-2 text-xs"
      >
        <XIcon className="mr-1 h-3.5 w-3.5" />
        Cancel
      </Button>
      <Button
        size="sm"
        onClick={onSave}
        disabled={isSaving || disabled}
        className="h-7 px-3 text-xs"
      >
        <FloppyDiskIcon className="mr-1 h-3.5 w-3.5" />
        {isSaving ? 'Saving...' : 'Save'}
      </Button>
    </div>
  )
}
